import { Modal } from "antd";
import useAuth from "src/hooks/useAuth";
import WrapLoginFormComponent from "src/components/wrap-login-form";

function ModalLoginComponent() {
  const { showPopupLogin, setShowPopupLogin }: any = useAuth();

  if (!showPopupLogin) {
    return null;
  }

  const closeLoginModal = () => {
    setShowPopupLogin(false);
  };

  return (
    <Modal
      title=""
      centered
      open={showPopupLogin}
      onOk={() => setShowPopupLogin(false)}
      onCancel={() => setShowPopupLogin(false)}
      width={1280}
      closable={false}
      footer={[]}
    >
      <WrapLoginFormComponent
        isModal={true}
        closeLoginModal={closeLoginModal}
      />
    </Modal>
  );
}

export default ModalLoginComponent;
